export default // eslint-disable-next-line max-len
'<svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 18 17"><path d="M579 388h18v2h-18v-2Zm0 15h18v2h-18v-2Zm8-5h10v2h-10v-2Zm0-5h10v2h-10v-2Zm-4 3.5-4 3.5v-7Z" transform="translate(-579 -388)" style="fill-rule:evenodd"/></svg>';
